import { render } from "./InvoiceViewFullKit.vue?vue&type=template&id=4ba33fa8"
import script from "./InvoiceViewFullKit.vue?vue&type=script&lang=js"
export * from "./InvoiceViewFullKit.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__